import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaUser, FaLock, FaHistory, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import SEO from './SEO';
import './Profile.css';

const Profile = () => {
  const { currentUser, logout } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [questionHistory] = useState([
    {
      id: 1,
      title: 'How to solve quadratic equations?',
      date: '2023-05-01',
      status: 'answered'
    },
    {
      id: 2,
      title: 'Best resources for learning React?',
      date: '2023-05-02',
      status: 'pending'
    }
  ]);

  const handlePasswordChange = (e) => {
    e.preventDefault();
    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordError('Please fill in all password fields.');
      setPasswordSuccess('');
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError('New passwords do not match.');
      setPasswordSuccess('');
      return;
    }
    // Here you would typically make an API call to change the password
    setPasswordError('');
    setPasswordSuccess('Password changed successfully!');
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  return (
    <>
      <SEO 
        title="User Profile - Student Helper"
        description="Manage your profile, change password, and view your question history. Personalize your Student Helper experience."
        keywords="user profile, account settings, password change, question history, student account"
      />
      <div className="profile-container">
        <motion.div 
          className="profile-header modern-profile-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="user-info">
            <div className="avatar">
              <FaUser />
            </div>
            <h1>{currentUser?.email}</h1>
          </div>
        </motion.div>

        <motion.div 
          className="password-section modern-password-section"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h2><FaLock /> Change Password</h2>
          <form onSubmit={handlePasswordChange} className="password-form">
            <input
              type="password"
              placeholder="Current Password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="password-input"
            />
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="password-input"
            />
            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="password-input"
            />
            <button type="submit" className="change-password-button">
              Change Password
            </button>
          </form>
          {passwordError && <div className="alert alert-error">{passwordError}</div>}
          {passwordSuccess && <div className="alert alert-success">{passwordSuccess}</div>}
        </motion.div>

        <motion.div 
          className="history-section modern-history-section"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <h2><FaHistory /> Question History</h2>
          <div className="history-list">
            {questionHistory.map(question => (
              <div key={question.id} className="history-item">
                <h3>{question.title}</h3>
                <div className="history-meta">
                  <span className="date">{question.date}</span>
                  <span className={`status ${question.status}`}>{question.status}</span>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div 
          className="logout-section modern-logout-section"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <button onClick={logout} className="logout-button">
            <FaSignOutAlt /> Logout
          </button>
        </motion.div>
      </div>
    </>
  );
};

export default Profile; 